import {useEffect, useState} from "react";
import axios from "axios";
import {getConfig} from "../../../../services/utils/ConfigUtils";
import {
	GET_ALL_QUARANTENE_URL, SEARCH_AXIOS_QUARANTENE_URL
} from "../../../../services/utils/ApiUrls";
import {clean, isEmpty} from "../../../../utils/GenericUtils";
import {decriptMessage} from "../../../../utils/SecureData";

export default function useGetAllQuarantene(stato, pageNumber, filters, filtersMonitoraggio, soggetto, value, scoreFilter, sort, dir, active, age) {
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(false);
	const [quarantene, setQuarantene] = useState([]);
	const [hasMore, setHasMore] = useState(false);
	
	function getData(stato, filters, filtersMonitoraggio, soggetto, scoreFilter, active, eta) {
		switch (stato) {
			default:
				return {};
			case "PAZIENTE":
				return {
					soggetto: soggetto
				}
			/*case "IN GESTIONE":
				return {
					active: true,
					score: scoreFilter === "" ? null : scoreFilter,
					tipo: filters === "" ? null : filters,
					compilatoMonitoraggioGiornaliero: filtersMonitoraggio === "Compilato giornaliero" ? true : null,
				}*/
			case "NUOVA":
			case "NUOVA NS":
			case "IN CORSO":
			case "IN ATTESA":
			case "CONCLUSA":
			case "GUARITO":
				let data = {
					stato: stato,
					active: active,
					eta: eta,
					protocollo: null,
					deleted: false,
					compilatoMonitoraggioGiornaliero: filtersMonitoraggio === "Compilato giornaliero" ? true : null,
				}
				if (filters.length > 0) {
					data = {
						...data,
						tipo: filters,
					}
				}
				if (filtersMonitoraggio.length > 0 && filtersMonitoraggio !== "Compilato giornaliero") {
					data = {
						...data,
						tipoMonitoraggio: filtersMonitoraggio,
					}
				}
				if (scoreFilter.length > 0) {
					data = {
						...data,
						score: scoreFilter,
					}
				}
				if (soggetto.tag) {
					data = {
						...data,
						tag: soggetto.tag,
					}
				}
				let di = null;
				let df = null;
				if (soggetto.dataInizio) {
					di = new Date(soggetto.dataInizio);
					di?.setHours(0);
					di?.setMinutes(0);
					di?.setSeconds(0);
					di?.setMilliseconds(0);
				}
				if (soggetto.dataFine) {
					df = new Date(soggetto.dataFine);
					df?.setHours(0);
					df?.setMinutes(0);
					df?.setSeconds(0);
					df?.setMilliseconds(0);
				}
				let paziente = {
					codF: soggetto.codF,
					nome: soggetto.nome,
					cognome: soggetto.cognome,
					cell: soggetto.cell,
					email: soggetto.email
				}
				if (soggetto.id) {
					return {
						id: soggetto.id
					}
				}
				data = {
					...data,
					soggetto: isEmpty(clean(paziente)) ? null : paziente,
					dataInizio: di,
					dataFine: df,
					active: soggetto.active ? soggetto.active : active,
					protocollo: soggetto.protocollo ? soggetto.protocollo : null,
					deleted: false,
				}
				
				return data;
		}
	}
	
	function getUrl(pageNumber, sort, dir) {
		return GET_ALL_QUARANTENE_URL + pageNumber + "/" + sort + "/" + dir;
	}
	
	useEffect(() => {
		if (stato !== "PAZIENTE") {
			setQuarantene([]);
		}
	}, [stato, filters, filtersMonitoraggio, soggetto, value, scoreFilter, sort, dir, active, age])
	
	useEffect(() => {
		if (value === "") {
			setLoading(true);
			setError(false);
			axios({
				method: "POST",
				url: getUrl(pageNumber, sort, dir),
				data: getData(stato, filters, filtersMonitoraggio, soggetto, scoreFilter, active, age),
				...getConfig(),
			}).then(response => {
					setQuarantene(prevState => {
						let newState = [...prevState, ...response.data];
						return newState.filter((object, index) => index === newState.findIndex(obj => JSON.stringify(obj) === JSON.stringify(object)))
					})
					setHasMore(response.data.length > 0);
					setLoading(false);
				})
				.catch(() => {
					setError(true);
					setLoading(false);
				})
		} else {
			setLoading(true);
			setError(false);
			let cancel
			axios({
				methods: "GET",
				url: SEARCH_AXIOS_QUARANTENE_URL + pageNumber,
				params: {
					search: value
				},
				cancelToken: new axios.CancelToken(c => cancel = c),
				headers: {
					Authorization: "Bearer " + decriptMessage(sessionStorage.getItem("key_asl_to")),
				}
			}).then(response => {
					setQuarantene(prevState => {
						let newState = [...prevState, ...response.data];
						return newState.filter((object, index) => index === newState.findIndex(obj => JSON.stringify(obj) === JSON.stringify(object)))
					})
					setHasMore(response.data.length > 0);
					setLoading(false);
				})
				.catch((e) => {
					if (axios.isCancel(e)) return
					setError(true);
					setLoading(false);
				})
			
			return () => cancel()
		}
	}, [stato, pageNumber, filters, filtersMonitoraggio, soggetto, value, scoreFilter, sort, dir, active, age])
	
	return {loading, error, quarantene, hasMore};
}
